import {i18n} from '@/plugins/i18n'

export const SettlementProviderVariant = {
    BASED_ON_SETTLEMENT_BANK:   1,
    FINNOTECH_AYANDE:           2,
    SHAHIN_KESHAVARZI:          3,
    SHAHIN_SADERAT:             4,
    SAMAN:                      5,
    SANBOD_PASARGAD:            6,
    SANBOD_PARSIAN:             7,
    SANBOD_SINA:                8,
    SANBOD_TEJARAT:             9,
    FARABOOM_MELLI:             10,
    mellat:                     11,
};

export const SettlementProviderVariantStr = {
    BASED_ON_SETTLEMENT_BANK:   i18n.t('wallets.settlement_provider_variant.based_on_settlement_bank'),
    FINNOTECH_AYANDE:           i18n.t('wallets.settlement_provider_variant.finnotech_ayande'),
    SHAHIN_KESHAVARZI:          i18n.t('wallets.settlement_provider_variant.shahin_keshavarzi'),
    SHAHIN_SADERAT:             i18n.t('wallets.settlement_provider_variant.shahin_saderat'),
    SAMAN:                      i18n.t('wallets.settlement_provider_variant.saman'),
    SANBOD_PASARGAD:            i18n.t('wallets.settlement_provider_variant.sanbod_pasargad'),
    SANBOD_PARSIAN:             i18n.t('wallets.settlement_provider_variant.sanbod_parsian'),
    SANBOD_SINA:                i18n.t('wallets.settlement_provider_variant.sanbod_sina'),
    SANBOD_TEJARAT:             i18n.t('wallets.settlement_provider_variant.sanbod_tejarat'),
    FARABOOM_MELLI:             i18n.t('wallets.settlement_provider_variant.faraboom_melli'),
    mellat:                     i18n.t('wallets.settlement_provider_variant.mellat'),

    get(variant) {
        let variant_str = null;

        Object.keys(SettlementProviderVariant).forEach(item => {
            if (SettlementProviderVariant[item] === variant) {
                variant_str = SettlementProviderVariantStr[item];
            }
        });

        return variant_str;
    }
};
